import { createWidgetSanitizer } from './sanitize-core.js';
let sanitizer;
export function sanitizeWidget(document) {
    sanitizer ??= createWidgetSanitizer(window);
    return sanitizer(document);
}
